import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor(public router:Router) { }

  ngOnInit(): void {
  }

  navegar(tipoLogueo){
    localStorage.setItem("tipoLogueo", tipoLogueo);
    this.router.navigateByUrl('/login/' + `${tipoLogueo}`);
  }

}
